import * as actions from 'reducers/purchaseSummaryMessage';

export function purchaseSummaryMessage(message) {
  return {
    type: actions.UPDATE_PURCHASE_SUMMARY_MESSAGE,
    message
  };
}
